<xm-loader [showLoader]="loading$ | async"></xm-loader>

<table
  #table
  [dataSource]="widgetsList"
  mat-table
  matSort>

  <!--  name -->
  <ng-container matColumnDef="{{columns[0]}}">
    <th *matHeaderCellDef scope="col" mat-header-cell mat-sort-header> {{TRS.name | translate}} </th>
    <td *matCellDef="let element" mat-cell> {{ element[columns[0]] }} </td>
  </ng-container>

  <!--  selector -->
  <ng-container matColumnDef="{{columns[1]}}">
    <th *matHeaderCellDef scope="col" mat-header-cell mat-sort-header> {{TRS.selector | translate}} </th>
    <td *matCellDef="let element" mat-cell> {{ element[columns[1]] }} </td>
  </ng-container>

  <!--  config -->
  <ng-container matColumnDef="{{columns[2]}}">
    <th *matHeaderCellDef scope="col" mat-header-cell mat-sort-header> {{TRS.config | translate}} </th>
    <td *matCellDef="let element" mat-cell>
      <bool-value [value]="element[columns[2]]"></bool-value>
    </td>
  </ng-container>

  <!-- Actions column -->
  <ng-container [matColumnDef]="ACTIONS_COLUMN">

    <th *matHeaderCellDef scope="col" class="text-end" mat-header-cell>
      @if (dashboardId) {
        <button (click)="onPaste()"
                [matTooltip]="TRS.paste | translate"
                mat-icon-button>
          <mat-icon>content_paste</mat-icon>
        </button>
        <button (click)="onAdd()"
                color="primary"
                [matTooltip]="TRS.addWidget | translate"
                mat-icon-button>
          <mat-icon>add</mat-icon>
        </button>
      }
    </th>

    <td *matCellDef="let row" class="text-end" mat-cell>

      <button (click)="onEdit(row); $event.stopPropagation()" mat-icon-button>
        <mat-icon>edit</mat-icon>
      </button>

    </td>

  </ng-container>
  <!-- ./ Actions column-->

  <tr *matHeaderRowDef="columns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: columns;"
      [ngClass]="{ 'list-item-active': this.managerService.activeWidget?.id === row.id}"
      mat-row></tr>

</table>

<div *ngIf="widgetsList?.data.length === 0" class="text-center">

  <h6>{{ TRS.empty | translate }}</h6>

  <button (click)="onAdd()" color="primary" mat-button>
    <mat-icon>add</mat-icon>
    {{ TRS.addWidget | translate }}
  </button>

</div>
